// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__q0IYY","gfeWrapper":"CalendarEvent_gfeWrapper__2Qz3x"};